import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import { useDispatch, useSelector } from 'react-redux'
import { mixrActions } from '../actions'
import Modal from 'srcReact/components/common2/Modal'
import SelectCalendarModal from 'srcReact/Pages/IntegrationSettings/components/SelectCalendarModal'
import queryString from 'query-string'
import ServerErrors from 'srcReact/components/popinsContent/ServerErrors'
import getThreeDotsOptions from './options'
import { redirectToPage, redirectToBack } from 'srcReact/helpers/history'
import CancelMixrPopup from './components/CancelMixrPopup'
import { isMobileScreen } from 'srcReact/helpers/utils'
import { checkNested } from 'srcReact/helpers/validator'
import { alertActions, AlertContainer } from 'srcReact/Alert'
import { commonActions } from 'srcReact/components'
import Widgets from './components/Widgets'
import { moderationReportActions } from 'srcReact/ModerationReportPage'
import Preview from './components/Preview'
import Layout from './components/Layout'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import SuspendModal from 'srcReact/ModerationReportPage/components/SuspendModal'
import { integrationActions } from 'srcReact/Pages/IntegrationSettings/actions'

export default function MixrHome(props) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [mixrId, setMixrId] = useState(0)
  const [moreOptions, setMoreOptions] = useState([])
  const [activeTab, setActiveTab] = useState(0)
  const [showAddToCalendarPopup, setShowAddToCalendarPopup] = useState(false)
  const [showCancelMixrPopup, setShowCancelMixrPopup] = useState(false)
  const [showErrorPopup, setShowErrorPopup] = useState(false)

  const [isSuggestedMixr, setIsSuggestedMixr] = useState(false)
  const [selectedTabFromUrl, setSelectedTabFromUrl] = useState('')
  const [feedIdToScroll, setFeedIdToScroll] = useState(0)
  const [totalActiveUsersCount, setTotalActiveUsersCount] = useState(0)
  const [scrollToTab, setScrollToTab] = useState(false)
  const [isWidgetsExpanded, setIsWidgetsExpanded] = useState(true)
  const [isSuspendModalOpen, setIsSuspendModalOpen] = useState(false)
  const [addToCalTriggered, setAddToCalTriggered] = useState(false)

  const {
    alert,
    login: { user: loggedInUser },
    common: { serverErrors: commonServerErrors, isNative, isTablet, isMobile, isDesktop },
    mixr: { mixr },
    mixr: {
      mixr: { location: mixrLocation, createMixrType, recurrence, createMixrLoading },
      mainLoading,
      serverErrors,
      participants,
      users,
      participantsStats,
      staff,
      widgets,
      moderation_info,
      createdMixrId,
      createdMixrUrl
    },
    integration: { activeIntegrations, triggerAddToCalendar }
  } = useSelector((state) => state)

  if (props.match.params.mixrId !== mixrId) {
    setMixrId(props.match.params.mixrId)
  }

  useEffect(() => {
    //this code will be executed when user clicks on more arrow on member overview component
    //it is to focus members on screen
    if (scrollToTab) {
      setTimeout(() => {
        if (isNative || isMobile) {
          window.scrollTo(0, 300)
        } else {
          window.scrollTo(0, 350)
        }
      }, 0)
      setScrollToTab(false)
    }
  }, [users])

  useEffect(() => {
    if (participantsStats) {
      setTotalActiveUsersCount(participantsStats.total)
    }
  }, [participantsStats])
  useEffect(() => {
    if (triggerAddToCalendar && addToCalTriggered) {
      setAddToCalTriggered(false)
      addToCalOnMixrCreation()
    }
    return () => {
      if (triggerAddToCalendar) {
        dispatch(integrationActions.clearData())
      }
    }
  }, [triggerAddToCalendar, addToCalTriggered])
  useEffect(() => {
    //clearing integration data on page load. So that when coming from create mixr page, it will start fresh//1206793451352331
    dispatch(integrationActions.clearData())
    let isSuggested = false
    let locationObj = queryString.parse(location.search)
    if (locationObj) {
      if (locationObj.reminder && locationObj.reminder === 'true') {
        handleAddToCalendar()
      } else if (locationObj.type) {
        if (locationObj.type === 'suggested') {
          // setShowSuggestedMixrPopup(true)
          setIsSuggestedMixr(true)
          isSuggested = true
        } else if (locationObj.type === 'created') {
          handleAddToCalendar()
        }
      }
      if (locationObj && locationObj.feed) {
        const feedId = locationObj.feed
        if (feedId && feedId > 0) {
          setFeedIdToScroll(feedId)
          if (isMobileScreen()) {
            redirectToPage(`/0/feed-content/mixr/${mixrId}/${feedId}`, isNative)
          }
        }
      } else {
        dispatch(commonActions.addUserPageView(appConstantSettings.EVENT_PAGE, mixrId))
      }
    } else {
      dispatch(commonActions.addUserPageView(appConstantSettings.EVENT_PAGE, mixrId))
    }
    if (!isSuggested) {
      const mixrId = props.match.params.mixrId
      setMixrId(mixrId)
    }

    const path = props && props.location ? props.location.pathname : null
    if (path) {
      const pathArr = path.split('/')
      const tab = pathArr.pop()
      if (tab === 'leadership') {
        setActiveTab(1)
        setSelectedTabFromUrl(tab)
      } else if (tab === 'participants') {
        setActiveTab(1)
      } else if (tab === 'media') {
        setActiveTab(2)
      } else if (tab === 'feed') {
        setActiveTab(0)
      }
    }

    ///
    const mixrPreviewData = localStorage.getItem('mixr_preview')
    if (mixrPreviewData && window?.location?.pathname?.includes('event/preview')) {
      dispatch(mixrActions.setPreviewMixrData(JSON.parse(mixrPreviewData), loggedInUser))
    }
    ///
    window.scrollTo(0, 0)

    return () => {
      const currentPreviewData = localStorage.getItem('mixr_preview')
      if (currentPreviewData) {
        localStorage.removeItem('mixr_preview')
      } else {
        dispatch(mixrActions.setInitialState())
      }
    }
  }, [])

  const selectParticipantsTab = () => {
    setScrollToTab(true)
    setActiveTab(1)
  }

  useEffect(() => {
    if (mixrId.toString() !== 'preview') {
      console.log('callinf mixr info')
      dispatch(mixrActions.getMixrDetails(mixrId, 'participants,staff,invited_all,group_active_members,rating'))
      dispatch(moderationReportActions.getFlagReasons())
    }
  }, [mixrId])

  useEffect(() => {
    if (mixr) {
      if (!isSuggestedMixr) {
        if (mixr.status === 'suggested') {
          redirectToPage(`/0/home/group/${mixr.group.id}`, isNative)
        }
      }
      if (mixr?.recurrence?.parent_id !== mixr.id && mixr.recurrence.parent_id > 0 && moderation_info?.is_suspended) {
        redirectToPage(`/0/home/event/${mixr.recurrence.parent_id}`, isNative)
      }
    }
  }, [mixr])

  const closeAddToCalendarPopup = () => {
    setShowAddToCalendarPopup(false)
  }

  const handleReinstate = () => {
    dispatch(moderationReportActions.reinstate(recurrence?.is_parent_event === 1 ? 'recurring_mixr' : 'mixr', mixrId))
  }

  const isMixrParticipant = () => {
    if (mixr && mixr.logged_user) {
      const { logged_user } = mixr
      return (
        logged_user.mixr_attending !== 'unknown' ||
        logged_user.mixr_role !== 'none' ||
        logged_user.group_role !== 'none' ||
        logged_user.group_attending === 'joined'
      )
    }
  }
  const isStaffMember = () => {
    if (mixr && mixr.logged_user) {
      const { logged_user } = mixr
      return logged_user.mixr_role === 'organizer' || logged_user.mixr_role === 'co-organizer'
    }
  }

  const isOrganizer = () => {
    if (mixr && mixr.logged_user) {
      const { logged_user } = mixr
      return logged_user.mixr_role === 'organizer'
    }
  }
  const isGroupMember = () => {
    if (mixr && mixr.logged_user) {
      const { logged_user } = mixr
      return logged_user.group_role !== 'none'
    }
  }

  const isPrivateGroup = () => {
    if (mixr && mixr.group) {
      const { group } = mixr
      return group.privacy_setting === 'private'
    }
  }

  const isPendingApproval = () => {
    if (mixr && mixr.logged_user) {
      const { logged_user } = mixr
      return logged_user.group_attending === 'pending'
    }
  }

  const isMixrNotOver = () => {
    if (mixr) {
      return mixr.status !== 'over'
    }
  }

  const isGoing = () => {
    const attending = mixr && mixr.logged_user ? mixr.logged_user.mixr_attending : ''
    return attending === 'going' || attending === 'in_person' || attending === 'virtual'
  }

  useEffect(() => {
    let errors = []
    if (serverErrors && serverErrors.message && serverErrors.message.length > 0) {
      errors = serverErrors.message
    } else if (commonServerErrors) {
      if (commonServerErrors.length > 0) {
        errors = commonServerErrors
      } else if (commonServerErrors.message && commonServerErrors.message.length > 0) {
        errors = commonServerErrors.message
      }
    }

    if (checkNested(serverErrors, 'redirect_to', 'group_id')) {
      redirectToPage(`/0/home/group/${serverErrors.redirect_to.group_id}`, isNative)
    } else if (errors && errors.length > 0 && errors !== 'cancelTokenError') {
      setShowErrorPopup(true)
    } else {
      setShowErrorPopup(false)
    }
  }, [serverErrors, commonServerErrors])

  useEffect(() => {
    if (createdMixrId > 0 && createdMixrUrl.length > 0) {
      //once mixr is created, add the mixr to the calendar.
      handleAddToCalendar()

      const type = createMixrType
      const mixrId = createdMixrId

      // After creating a new event clear mixr_preview, created_mixr_id, and created_mixr_url
      const keysToRemove = ['mixr_preview', 'created_mixr_id', 'created_mixr_url']
      keysToRemove.forEach((key) => localStorage.removeItem(key))

      //clear createdMixrId, createMixrType and  createdMixrUrl
      dispatch(mixrActions.clearCreatedMixrValues())

      if (type === 'suggest' && mixr?.group?.group_id) {
        redirectToPage(`/0/home/group/${mixr.group.group_id}?type=suggested`, isNative)
      } else {
        redirectToPage(`/0/home/event/${mixrId}?type=created`, isNative)
      }
    }
  }, [createdMixrId, createdMixrUrl])

  const addToCalOnMixrCreation = () => {
    const defaultCalendar = activeIntegrations?.list?.find((x) => x.is_default === 1 && x.usage === 'add_to_calendar')
    if (mixrId && defaultCalendar) {
      dispatch(
        integrationActions.postEventToCalendar(
          mixrId,
          defaultCalendar.external_api,
          defaultCalendar.id_external_api_auth
        )
      )
    } else {
      setShowAddToCalendarPopup(true)
    }
  }

  const closeErrorPopup = () => {
    setShowErrorPopup(false)
  }
  const closeCancelMixrPopup = () => {
    setShowCancelMixrPopup(false)
  }

  const handleAddCoorganizer = (userId) => {
    if (mixr) {
      dispatch(mixrActions.addStaffRole(mixrId, userId, 'co-organizer'))
    }
  }
  const handleRemoveCoorganizer = (userId) => {
    if (mixr) {
      dispatch(mixrActions.removeStaffRole(mixrId, userId, 'staff'))
    }
  }

  const handleWidgetToggle = (isExpanded) => {
    setIsWidgetsExpanded(isExpanded)
  }

  const hideSuspendModal = () => {
    setIsSuspendModalOpen(false)
  }

  const handleSuspend = (message) => {
    const orgId = getCurrentOrgId()
    if (moderation_info && moderation_info.moderation_id) {
      dispatch(moderationReportActions.suspend(moderation_info.moderation_id, orgId, message, mixr.id))
      redirectToBack(isNative)
    }
  }

  const handleAddToCalendar = () => {
    setAddToCalTriggered(true)
    const organizationId = getCurrentOrgId()
    dispatch(integrationActions.getActiveIntegrations(organizationId, 'add_to_calendar'))
  }

  return (
    <PageContainer
      pageTitle={mixr?.name ? `${mixr.name} - mixr` : 'mixr'}
      pageClassName={styles.mainPage}
      withFooter={false}
      withSidebar={true}
      hasWidgets={
        moderation_info.is_suspended || (mixr && (mixr.is_preview || mixr.status === 'cancelled')) ? false : true
      }
      onWidgetToggle={handleWidgetToggle}
      renderWidgets={() => {
        if (mixr) {
          return (
            <Widgets
              isMixrNotOver={isMixrNotOver()}
              mixrId={mixrId}
              widgets={widgets}
              latitude={mixrLocation && mixrLocation.latitude}
              longitude={mixrLocation && mixrLocation.longitude}
              handleAddToCalendar={() => mixr && !mixr.is_preview && handleAddToCalendar()}
              isMixrOver={!isMixrNotOver()}
              isStaffMember={isStaffMember()}
              loggedInUser={loggedInUser}
              handleShowMoreUsers={() => {
                window.scrollTo(0, 140)
                setActiveTab(1)
              }}
              handleShowMoreMedia={() => {
                window.scrollTo(0, 140)
                setActiveTab(2)
              }}
              handleAddCoorganizer={handleAddCoorganizer}
              handleRemoveCoorganizer={handleRemoveCoorganizer}
            />
          )
        }
      }}>
      {/* {alert && alert.message ? (
        <AlertContainer
          title={t('error.error_alert_title')}
          message={alert.message}
          show={!!alert.message}
          handleClose={() => dispatch(alertActions.clear())}
        />
      ) : null} */}
      {mixr?.is_preview && !createMixrLoading && <Preview {...props} />}

      <Layout
        mixrId={props.match.params.mixrId || createdMixrId}
        isDesktop={isDesktop}
        isMixrNotOver={isMixrNotOver()}
        isMixrParticipant={isMixrParticipant()}
        isGoing={isGoing()}
        isGroupMember={isGroupMember()}
        isStaffMember={isStaffMember()}
        isOrganizer={isOrganizer()}
        isPrivateGroup={isPrivateGroup()}
        isPendingApproval={isPendingApproval}
        isSuggestedMixr={isSuggestedMixr}
        totalActiveUsersCount={totalActiveUsersCount}
        activeTab={activeTab}
        feedIdToScroll={feedIdToScroll}
        selectedTabFromUrl={selectedTabFromUrl}
        setShowCancelMixrPopup={setShowCancelMixrPopup}
        setActiveTab={setActiveTab}
        setShowAddToCalendarPopup={setShowAddToCalendarPopup}
        setFeedIdToScroll={setFeedIdToScroll}
        selectParticipantsTab={selectParticipantsTab}
        getThreeDotsOptions={getThreeDotsOptions}
        handleAddCoorganizer={handleAddCoorganizer}
        handleRemoveCoorganizer={handleRemoveCoorganizer}
        handleReinstate={handleReinstate}
        isWidgetsExpanded={isWidgetsExpanded}
        setIsSuspendModalOpen={setIsSuspendModalOpen}
        handleAddToCalendar={handleAddToCalendar}
      />
      {showAddToCalendarPopup && (
        <Modal isOpen={showAddToCalendarPopup} handleClose={closeAddToCalendarPopup}>
          <SelectCalendarModal
            mixrRecurrenceRule={mixr && mixr.recurrence.add_to_cal_recurrence_rule}
            mixrId={mixrId}
            closeModal={closeAddToCalendarPopup}
            isMixrOrganizer={isOrganizer()}
          />
        </Modal>
      )}
      {showErrorPopup && (
        <Modal isOpen={showErrorPopup} handleClose={closeErrorPopup}>
          <ServerErrors
            errors={
              (serverErrors && serverErrors.message && serverErrors.message.length > 0 && serverErrors.message) ||
              (commonServerErrors.length > 0 && commonServerErrors) ||
              commonServerErrors.message
            }
            title={t('mixrHome.serverError')}
            closeModal={closeErrorPopup}
          />
        </Modal>
      )}

      {showCancelMixrPopup && (
        <Modal isOpen={showCancelMixrPopup} handleClose={closeCancelMixrPopup}>
          <CancelMixrPopup
            isParentMixr={mixr?.recurrence?.is_parent_event === 1}
            mixrId={mixrId}
            isRecurrentMixr={mixr && mixr.recurrence && mixr.recurrence.type && mixr.recurrence.type !== 'none'}
            closeModal={closeCancelMixrPopup}
          />
        </Modal>
      )}
      {isSuspendModalOpen && (
        <SuspendModal
          isOpen={isSuspendModalOpen}
          hideModal={hideSuspendModal}
          objectType='mixr'
          objectName={mixr.name}
          onSuspend={handleSuspend}
        />
      )}
      {/* {showSuggestedMixrPopup && (
        <Modal isOpen={showSuggestedMixrPopup} handleClose={closeSuggestedMixrPopup}>
          <CreatedSuggestedMixrPopin closeModal={closeSuggestedMixrPopup} />
        </Modal>
      )} */}
    </PageContainer>
  )
}
